export function generateUUID(): string {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // versão 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function generateShortUUID(): string {
    return Math.random().toString(36).substring(2, 9); // nosemgrep -- id de UI/config (campos, eventos, DOM), não é segredo
}

export function formatCurrency(value: number) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
};

export function getInitials(fullName: string): string {
    if (!fullName) return ""

    const parts = fullName.trim().split(/\s+/)

    const firstInitial = parts[0]?.charAt(0).toUpperCase() || ""

    const secondInitial = parts.length > 1
        ? parts[parts.length - 1]?.charAt(0).toUpperCase()
        : ""

    return firstInitial + secondInitial
}

export function htmlToText(html: string): string {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    let text = tempDiv.textContent || tempDiv.innerText || "";

    text = text.replace(/\u00A0/g, " ").trim();

    return text;
}

export function extractNumbers(text: string){
    return text.replace(/\D/g, "");
}

export function normalizeString(str: string): string {
    return str.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

export function removeAccents(str: string): string {
    if (!str) return "";
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function removeSpecialChars(str: string): string {
    if (!str) return "";
    return str.replace(/[^\p{L}\p{N}\s]+/gu, '');
}

export function linkify(text: string): string {
    if (!text) return "";

    const escapeHtml = (value: string) => value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    const urlRegex = /(https?:\/\/[^\s<]+)/g;

    return escapeHtml(text).replace(urlRegex, (match) => {
        const trailingPunctuation = match.match(/[.,!?;:]+$/)?.[0] ?? "";
        const url = trailingPunctuation ? match.slice(0, -trailingPunctuation.length) : match;

        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>${trailingPunctuation}`;
    });
}

export function sanitizeHtml(html: string): string {
    return html
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<script[\s\S]*?<\/script>/gi, '');
}